import script from "./CurrentPodcast.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentPodcast.vue?vue&type=script&setup=true&lang=js"

import "./CurrentPodcast.vue?vue&type=style&index=0&id=22d0474c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22d0474c"]])

export default __exports__